import { render, staticRenderFns } from "./AdministrativePermitsResolutionFilter.vue?vue&type=template&id=585e7534&scoped=true"
import script from "./AdministrativePermitsResolutionFilter.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsResolutionFilter.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsResolutionFilter.vue?vue&type=style&index=0&id=585e7534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e7534",
  null
  
)

export default component.exports